<template>
  <b-modal v-model="showModal" size="lg" @hidden="cancelar" button-size="md" hide-footer :title="prefix + title">
    <template v-if="isEdit">
      <ConsultaItemBemPermanenteEdit ref="editForm" @fecharModal='cancelar' :id="id" :prefix="[prefix + title]"></ConsultaItemBemPermanenteEdit>
    </template>
    <template v-else>
      <ConsultaItemBemPermanenteView :id="id" :prefix="[prefix + title]"></ConsultaItemBemPermanenteView>
    </template>

    <b-form-row class='justify-content-center'>
      <b-button id="cancelarModalConsultaIBP" pill style="height: 30px" @click="cancelar" size="sm" variant="danger">
        <div class="btn-size-alinhamento">
          <b-icon icon="x-circle" />
          <b-tooltip target="cancelarModalConsultaIBP" title="Cancelar"></b-tooltip>
        </div>
      </b-button>
      <b-button v-if='isEdit' @click="submitForm" id="salvarform" class='mx-2' type="submit" variant="success" style="height: 30px" pill size="sm">
        <div class="btn-size-alinhamento">
          <b-icon icon="check-circle" />
        </div>
        <b-tooltip target="salvarform" title="Salvar" triggers="hover"></b-tooltip>
      </b-button>
    </b-form-row>
  </b-modal>
</template>

<script>
import ConsultaItemBemPermanenteEdit from '@/modules/patrimonio/consulta-item-bem-permanente/ConsultaItemBemPermanenteEdit.vue'
import ConsultaItemBemPermanenteView from '@/modules/patrimonio/consulta-item-bem-permanente/ConsultaItemBemPermanenteView.vue'

export default {
  name: "ModalItemBemPermanenteView",
  components: {
    ConsultaItemBemPermanenteView,
    ConsultaItemBemPermanenteEdit,
  },
  props: {
    id: Number,
    title: { type: [String, Array], default: "Item Bem Permanente" },
    prefix: { type: [String, Array], default: "" },
    isEdit: { type: Boolean, default: false },
  },
  data() {
    return {
      showModal: true,
    }
  },
  methods: {
    cancelar() {
      this.showModal = false
      this.$emit('fecharModal')
    },
    submitForm() {
      this.$refs.editForm.submitForm();
    }
  }
}
</script>

<style scoped>
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding-top: 1rem;
}
</style>